
export const user = state => state.user

export const college = state => state.college

export const history_search = state => state.history_search



// WEBPACK FOOTER //
// ./src/store/getters.js